module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.password) ? _c('md-card', {
    staticClass: "landing single"
  }, [_c('md-card-content', [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": require("../assets/landing.svg"),
      "alt": "Body Guard"
    }
  }), _vm._v(" "), _c('md-card', {
    staticClass: "card"
  }, [_c('md-card-area', {
    attrs: {
      "md-inset": ""
    }
  }, [_c('md-card-header', {
    staticClass: "md-primary header"
  }, [_c('h1', {
    staticClass: "md-title logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.svg"),
      "alt": "BodyGuard Logo"
    }
  })]), _c('p', [_vm._v("BodyGuard 323 "), _c('span', [_vm._v("ColorVision ™")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "subLanding"
  }, [_c('p', [_c('span', [_vm._v("Your digital ")]), _c('span', [_vm._v("training guide")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/front"
    }
  }, [_vm._v("Start")]), _vm._v(" "), _c('img', {
    staticClass: "device",
    attrs: {
      "src": require("../assets/device.png"),
      "alt": "Body Guard"
    }
  })], 1)], 1)], 1)], 1)], 1) : _c('md-card', {
    staticClass: "single password"
  }, [_c('md-card-content', [_c('md-card', {
    staticClass: "card"
  }, [_c('md-card-area', {
    attrs: {
      "md-inset": ""
    }
  }, [_c('div', {
    staticClass: "subLanding"
  }, [_c('h2', [_vm._v("Enter Password To Continue")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer),
      expression: "answer"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.answer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.answer = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.checkPassword(_vm.answer)
      }
    }
  })])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5d5e6ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Landing.vue
// module id = 763
// module chunks = 0